import React, { useState, useContext } from 'react';

export interface SelectedPlanContextInterface {
  selectedPlan?: Billing.IPlan;
  setSelectedPlan?: (product: Billing.IPlan) => void;
}

const SelectedPlanContext = React.createContext<SelectedPlanContextInterface>({});

export const SelectedPlanContextProvider: React.FunctionComponent = ({ children }) => {
  const [selectedPlan, setSelectedPlan] = useState();

  return (
    <SelectedPlanContext.Provider value={{ selectedPlan, setSelectedPlan }}>{children}</SelectedPlanContext.Provider>
  );
};

export const SelectedPlanContextConsumer = SelectedPlanContext.Consumer;

export const useSelectedPlan = () => useContext(SelectedPlanContext);

export default SelectedPlanContext;
